var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 39,
    viewBox: "0 0 59 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_5422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 0.5H5C2.51472 0.5 0.5 2.51472 0.5 5V34C0.5 36.4853 2.51472 38.5 5 38.5H54C56.4853 38.5 58.5 36.4853 58.5 34V5C58.5 2.51472 56.4853 0.5 54 0.5Z",
    stroke: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4167 13.3989L23.333 25.6268H26.6655L28.7509 13.3989H25.4167Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.539 13.4123L17.275 21.7513L16.9271 20.4922C16.2833 18.9751 14.4559 16.7962 12.3105 15.4231L15.2951 25.6204L18.8213 25.6144L24.0695 13.4097L20.539 13.4123Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6616 14.2878C15.4679 13.543 14.9065 13.321 14.2096 13.2944H9.04286L9 13.5379C13.0208 14.5133 15.6813 16.8635 16.7853 19.6895L15.6616 14.2878Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5057 15.7432C36.5959 15.7261 37.3862 15.9644 37.9999 16.2112L38.3008 16.3526L38.7516 13.7024C38.0916 13.4547 37.0571 13.189 35.7662 13.189C32.4731 13.189 30.152 14.8475 30.134 17.2243C30.1126 18.9806 31.7874 19.9612 33.0525 20.5466C34.3511 21.1466 34.7865 21.528 34.7805 22.0637C34.7702 22.8823 33.7451 23.2577 32.7877 23.2577C31.4531 23.2577 30.7443 23.0734 29.6497 22.6174L29.2203 22.422L28.7515 25.1588C29.5315 25.5008 30.9706 25.7948 32.4646 25.8102C35.9676 25.8102 38.2442 24.1714 38.2682 21.6317C38.2828 20.2423 37.3939 19.182 35.4679 18.312C34.3022 17.7446 33.5891 17.3675 33.596 16.7949C33.596 16.2866 34.2011 15.7432 35.5057 15.7432Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3037 13.4126H44.7289C43.9292 13.4126 43.3343 13.6303 42.9829 14.4274L38.0347 25.6336H41.5343C41.5343 25.6336 42.1052 24.1267 42.2346 23.7968C42.6178 23.7968 46.018 23.8019 46.5023 23.8019C46.6017 24.2287 46.9086 25.6336 46.9086 25.6336H50.0002L47.3037 13.4126ZM43.1937 21.2939C43.468 20.5919 44.5214 17.8765 44.5214 17.8765C44.5034 17.91 44.7932 17.1694 44.9654 16.7091L45.19 17.7634C45.19 17.7634 45.8286 20.6828 45.9623 21.2939H43.1937Z",
    fill: "#3D2C06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_5422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visaIcon.e7fb8b4814a38591dd75eda89b738a80.svg";
export { ForwardRef as ReactComponent };